export default (function (props) {
  return {
    eventName: 'Registration Form Displayed',
    flowType: 'proactive',
    platform: 'web',
    stepCount: 1,
    stepNumber: 1,
    product: props.metadata.applicationName,
    reason: props.metadata.userAction
  };
});